export const GET_EMPLOYEES = 'providers/workforce/Employees/GET_EMPLOYEES';
export const CREATE_EMPLOYEE = 'providers/workforce/Employees/CREATE_EMPLOYEE';
export const DELETE_EMPLOYEE = 'providers/workforce/Employees/DELETE_EMPLOYEE';
